module.exports = __webpack_public_path__ + "img/20180815_150119_050.5a279d3e.jpg";